import $ from "jquery"
import './../scss/style.scss';

// svgstore
window.baseUrl = '/local/dist/';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initLocomotiveScroll } from './scroll'
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { loadingSequence } from "./loading";
import { initEventForm } from "./shared/event-form";
import { initFormValidation } from "./shared/form-validator";
import { initScrollTo } from "./shared/scroll-to";
import { initGloId } from "./globtrak/glo-id";
import { initGloVideo } from "./globtrak/glo-video";
import { initHeaderDropdown } from "./shared/header-dropdown";
import { initGloModal } from "./globtrak/glo-modal";
import { initGloAnimate } from "./globtrak/glo-animate";


$(() => {
  // # on ready
  // initLocomotiveScroll()
  initCommon()
  initCookies()
  initEventForm()
  initFormValidation()
  initScrollTo()
  initGloId()
  initGloVideo()
  initGloModal()
  initGloAnimate()
  initHeaderDropdown()
  WCAG.init()
  // loading sequence
  loadingSequence()
});

$(window).on( "load", ()=> {
  // # on load
});